export default __webpack_public_path__ + "static/media/webCam-380x380.c251eaa0.png";